export default __webpack_public_path__ + "static/wella-65eb608a6bb99cb5c8ef4763339a4fa4.jpg";